import Metrics from './Metrics';
import MetricsContainer from './MetricsContainer';

export { MetricsContainer };
export default Metrics;



// WEBPACK FOOTER //
// ./src/components/Metrics/index.js